import { CallEmsApi, iEmsApiResponseBody } from "./TenantAPI";

export interface GetSLATimeModelResponse {
    items: SLATimeModel[];
}

export interface SLATimeModel {
    id: number;
    title: string;
}

export async function GetSLATimeModels(tenantToken: string): Promise<iEmsApiResponseBody<GetSLATimeModelResponse>> {
    return await CallEmsApi<GetSLATimeModelResponse>(tenantToken, "GET", `SLA/TimeModels/`);
}
